import * as React from "react";
/* empty css                 */
function FacetHeader({ title, SearchButton, ClearButton }) {
  return /* @__PURE__ */ React.createElement("div", { className: "facet-header" }, /* @__PURE__ */ React.createElement("div", { className: "facet-header__heading", "data-t": "facet-heading" }, /* @__PURE__ */ React.createElement("span", null, title), ClearButton), SearchButton);
}
export {
  FacetHeader as default
};
//# sourceMappingURL=FacetHeader.js.map
